import React from "react";
import { TableColumnsType } from "antd";
import ReusableTable from "../../../../../../../../global components/Table/Table";
import ReusablePopover from "../../../../../../../../global components/Popover/ReuseablePopover";
import ActionsPopOver from "../ActionsPopOver";
import Elipses from "../../../../../../../../global components/Icons/Elipses";
import { PaginatedGetPendingRequestType } from "../../../../../../../../libs/Utils/Types/NumberManagement";
import dayjs from "dayjs";
import clsx from "clsx";
import s from "./PendingRequestsTable.module.scss";
type ColumnType = {
  userName: string;
  serialNumber: number;
  key: string;
  country: string;
  areaCode: string;
  requestDate: string;
  actions: string;
  status: string;
};
type PropType = {
  isLoading: boolean;
  data: PaginatedGetPendingRequestType["data"];
  mutate: () => void;
};
function PendingRequestsTable({ data, isLoading, mutate }: PropType) {
  const columns: TableColumnsType<ColumnType> = [
    {
      title: "S/N",
      key: "serialNumber",
      dataIndex: "serialNumber",
      render: (serialNumber: string) => <span>{serialNumber}</span>,
    },
    {
      title: "User",
      key: "userName",
      dataIndex: "userName",
      render: (userName: string) => <span>{userName}</span>,
    },
    {
      title: "Request date",
      key: "requestDate",
      dataIndex: "requestDate",
      render: (requestDate: string) => <span>{requestDate}</span>,
    },
    {
      title: "Preferred Country",
      key: "country",
      dataIndex: "country",
      render: (country: string) => <span>{country}</span>,
    },
    {
      title: "Preferred Area Code",
      key: "areaCode",
      dataIndex: "areaCode",
      render: (areaCode: string) => <span>{areaCode}</span>,
    },
    {
      title: "Staus",
      key: "status",
      dataIndex: "status",
      render: (status: string) => (
        <span
          className={clsx(
            s.status,
            s.statusCell,
            status === "approved"
              ? s.successful
              : status === "rejected" || status === "deleted"
              ? s.failed
              : s.pending
          )}
        >
          {status.charAt(0).toUpperCase() + status.slice(1)}
        </span>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      dataIndex: "actions",
      render: (
        actions: string,
        record: {
          key: string;
          status: string;
          areaCode: string;
          country: string;
        }
      ) => (
        <ReusablePopover
          trigger={"hover"}
          content={
            <ActionsPopOver
              id={record.key}
              mutate={mutate}
              code={record.areaCode}
              country={record.country}
              status={record.status}
            />
          }
        >
          {" "}
          <Elipses height={24} width={18} />
        </ReusablePopover>
      ),
    },
  ];

  const dataSource: ColumnType[] = data.map((item, index) => ({
    actions: "",
    key: item.id,
    serialNumber: index + 1,
    status: item.status,
    areaCode: item.areaCode,
    country: item.country,
    requestDate: dayjs(item.updatedAt).format("DD/MM/YYYY"),
    userName: item.user
      ? item.user?.firstName + " " + item.user?.lastName
      : "N/A",
  }));
  return (
    <ReusableTable
      columns={columns}
      dataSource={dataSource || []}
      loading={isLoading}
    />
  );
}

export default PendingRequestsTable;
